import React from 'react';
import Editor from 'src/constrains/BraftEditor';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { Modal, ModalFooter } from 'src/components/Antd';
import css from './css.module.less';
import { RangePicker } from '@/src/components';
import { get } from 'lodash';
import moment from 'moment';
import { useSalesChannelProductLinkSet } from 'src/components/LinkModule/hooks';
import { LinkModuleType } from '@/src/types/common/linkType';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const _Modal = (props) => {
  const {
    salesChannelUuid,
    data: oriData,
    onOk,
    onCancel,
    visible,
    isPrimary,
    scTimezoneUTC,
  } = props;

  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const linkSet = useSalesChannelProductLinkSet({ salesChannelUuid });

  const content = get(oriData, 'content');
  const uuid = get(oriData, 'uuid');
  const status = get(oriData, 'status');
  const _startTime = get(oriData, 'startTime', null);
  //console.log('status', status);
  const [startTime, setStartTime] = React.useState(_startTime);

  const _startInDate = startTime
    ? moment(startTime).format('YYYY-MM-DD')
    : null;
  const _startInTime = startTime ? moment(startTime).format('HH:mm') : null;

  const _endTime = get(oriData, 'endTime', null);
  const [endTime, setEndTime] = React.useState(_endTime);
  const _endInDate = endTime ? moment(endTime).format('YYYY-MM-DD') : null;
  const _endInTime = endTime ? moment(endTime).format('HH:mm') : null;

  const [data, setData] = React.useState(content);
  const [rangeHasError, setRangeHasError] = React.useState(false);
  const [contentErr, setContentErr] = React.useState(false);

  const [contentIsEmpty, setContentErrIsEmpty] = React.useState(!!!content);

  // React.useEffect(() => {
  //   if (_editor.current && _editor.current.setData && oriData !== data) {
  //     _editor.current.setData(oriData);
  //   }
  // }, [oriData]);
  const _editor = React.useRef<any>(null);
  const _linkSet = {
    ...linkSet,
    excludeLinkType: [
      {
        linkType: LinkModuleType.SysModule,
        groups: [
          LinkModuleType.ShareMiniProgram,
          //LinkModuleType.CustomerService,
        ],
      },
    ],
  };
  const handleOnOk = () => {
    if (!startTime) {
      setRangeHasError(true);
      return;
    } else if (contentIsEmpty) {
      setContentErr(true);
      return;
    } else {
      const res = {
        uuid,
        content: data,
        startTime,
        endTime,
        status,
        salesChannelUuid,
      };

      if (onOk) {
        onOk(res);
      }
    }
  };
  const handleOnContentChange = ({ data, isEmpty }) => {
    console.log(data);
    setContentErrIsEmpty(isEmpty);
    setContentErr(false);
    setData(data);
  };
  return (
    <Modal
      visible={visible}
      title={getI18n('salesChannelCheckout.index.checkoutPromotionContent')}
      onCancel={onCancel}>
      <div className={css.modalContainer}>
        <ItemWrapper title={getI18n('general.sider.content')}>
          <Editor
            help={getI18n('salesChannelCheckout.index.contentcannotbeempty')}
            err={contentErr}
            configFront={['undo', 'redo', 'separator', 'bold']}
            configBack={['code']}
            linkSet={_linkSet}
            ref={(e) => (_editor.current = e)}
            id='SalesChannelLegalPageEditorContent'
            data={data}
            onChange={handleOnContentChange}
            contentStyle={{
              height: 123,
              boxShadow: 'inset 0 1px 3px rgba(0,0,0,.1)',
            }}
            //   configFront={configFront}
            //   configBack={configBack}
          />
        </ItemWrapper>
        {isPrimary && (
          <ItemWrapper
            title={`${getI18n(
              'salesChannelCheckout.index.timeSetting',
            )} (UTC ${scTimezoneUTC})`}>
            <RangePicker
              disabled={!isPrimary}
              error={{
                hasError: rangeHasError,
                errorMsg: getI18n(
                  'salesChannelCheckout.index.pleaseselectstarttime',
                ),
              }}
              id={`time-picker-${Math.random()}`}
              value={{
                beginDate: _startInDate,
                beginTime: _startInTime,
                endDate: _endInDate,
                endTime: _endInTime,
              }}
              occupiedRanges={[]}
              onChange={(e) => {
                setRangeHasError(false);
                const beginDate = get(e, 'beginDate');
                const beginTime = get(e, 'beginTime');
                const endDate = get(e, 'endDate');
                const endTime = get(e, 'endTime');
                if (beginDate && beginTime) {
                  setStartTime(`${beginDate} ${beginTime}`);
                } else {
                  setStartTime(null);
                }
                if (endDate && endTime) {
                  setEndTime(`${endDate} ${endTime}`);
                } else {
                  setEndTime(null);
                }
              }}
            />
          </ItemWrapper>
        )}
      </div>
      <ModalFooter
        okText={getI18nFromGeneral('general.antd.Modal.ModalFooter.confirm')}
        cancelText={getI18nFromGeneral('general.commonHeader.discard_text')}
        onOk={handleOnOk}
        onCancel={onCancel}
        // hideOkButton={!category || (isDob && !(date.y || date.m || date.d))}
      />
    </Modal>
  );
};
export default _Modal;
